export default __webpack_public_path__ + "static/media/1.52fa75ae.png";